module.exports = __webpack_public_path__ + "img/symbol_2.30049689.png";